// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"443":"about","860":"menu"}[chunkId] || chunkId) + "." + {"61":"5af291ef","372":"ac82dc86","443":"c86d1fc2","826":"259d6bbc","860":"bb66d639","981":"01a0c1e0"}[chunkId] + ".js";
};